import $ from 'jquery'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

export const init = async function () {
  
  gsap.registerPlugin(ScrollTrigger)
  
  const rotateProductBox = gsap.to('.LPAnimation-product-box', {
    keyframes: [{translateZ: 0, rotateY: 0, rotateX: 0, delay: 0}, {translateZ: window.innerHeight*.5, rotateY: 0,rotateX: 15, delay: 0}, {translateZ: window.innerHeight*.5, rotateY: 180, rotateX: -15, delay: 0}]
  })
  
  ScrollTrigger.create({
    trigger: '#js-lp-animation',
    start: 'top top',
    end: window.innerWidth > 1023 ? '+=1500' : '+=1000',
    pin: true,
    animation: rotateProductBox,
    scrub: true
  })

}